import IWall from 'components/interfaces/IWall';
import IWallMetaData from 'components/interfaces/IWallMetaData';

import {
  SET_IDENTIFIER,
  SET_META_DATA,
  SET_PREVIOUS,
  SET_PROPERTIES,
  SET_RAW,
} from './types';

export const setPreviousWall = (
  previous: IWall
): {
  type: string;
  previous: IWall;
} => ({
  type: SET_PREVIOUS,
  previous,
});

export const setRawWall = (
  raw: any
): {
  type: string;
  raw: any;
} => ({
  type: SET_RAW,
  raw,
});

export const setWallIdentifier = (
  identifier: string
): {
  type: string;
  identifier: string;
} => ({
  type: SET_IDENTIFIER,
  identifier,
});

export const setWallMetaData = (
  metaData: IWallMetaData
): {
  type: string;
  metaData: IWallMetaData;
} => ({
  type: SET_META_DATA,
  metaData,
});

export const setWall = (
  properties: IWall
): {
  type: string;
  properties: IWall;
} => ({
  type: SET_PROPERTIES,
  properties,
});
